<div class="preference-options">
    <div class="options-container">
        <ng-container *ngFor="let preference of selectedPreferences">
            <div class="selected-preference-option">
                <div class="bullet" [style.background-color]="preference.color"></div>
                <p class="option-text">{{preference.label}}<br/>{{preference.subLabel}}</p>
            </div>
        </ng-container>
    </div>
</div>